import React from 'react';
import ReactDOM from 'react-dom/client';
import { Programs } from './Programs';
import type { PageData } from './types';

const pageDataEl = document.getElementById('pageData');
if (!pageDataEl) { throw new Error('Missing #pageData element'); }
const pageData: PageData = JSON.parse(pageDataEl.textContent!);

const container = document.getElementById('programs-root');
if (!container) { throw new Error('Missing #programs-root element'); }
const root = ReactDOM.createRoot(container);
root.render(React.createElement(Programs, pageData));

if (module.hot) { module.hot.accept(); }
